<template>
    <tr class="row-one-line indexable">
        <td class="td-padding" v-if="documentType === 'operationDocument'">
            <input type="checkbox" class="document-checkbox"
                   v-model="checkboxChecked"
                   :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                   :name="checkboxName"
                   @click="handleCheckboxChange($event)"
                   :disabled="disabled">
        </td>
        <td class="td-padding table-icons" v-if="documentType === 'contractorDocument'">
            <a class="icon-delete-embedded" data-toggle="tooltip" data-placement="top"
               :disabled="disabled"
               :class="{disabledIcon: disabled}"
                @click="handleDocumentDelete(allocationAmount)">
                <i class="fa fa-trash"></i>
            </a>
        </td>
        <td class="td-padding document_number" :colspan="modalType === 'localContractor' ? 0 : colspan"><truncated-text :text="document.document_number" :max_length="20"/></td>
        <td class="td-padding date_issued" v-show="modalType === 'localContractor'">{{ document.date_issued }}</td>
        <td class="td-padding text-right gross_amount" v-show="modalType === 'localContractor'">{{ document.document_gross_amount_list}}</td>
        <td class="td-padding text-right document_balance" v-show="modalType === 'localContractor'">{{documentBalance}}</td>
        <td v-show="modalType === 'localContractor'">
            <input type="text" class="form-control text-right balance_after_allocation money" placeholder="0,00" readonly
                   :name="documentBalanceAfterAllocationName"
                   :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                   v-model="documentBalanceAfterAllocation"
                   :disabled="disabled">
        </td>
        <td class="td-padding currency" v-show="modalType === 'localContractor'">
            {{ document.currency | toUpper }}
        </td>
        <td :class="{'has-error' : hasError}">
            <input type="text" class="form-control text-right document-amount split money" placeholder="0,00" data-exchange="1"
                   :name="documentConnectedAmountName"
                   :title="document.document_id"
                   :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                   :readonly="readonlyProperties.documentAmount"
                   v-model="allocationAmount"
                   @change="handleAmountChange"
                   @keydown="preventNonNumbers($event)"
                   :disabled="disabled">
            <span class="help-block text-danger" v-if="hasError">{{ errorMessage[0] }}</span>
        </td>

        <td class="td-padding source_currency">
            {{ source.currency | toUpper  }}
        </td>
        <td>
            <input type="text" v-if="showExchangeRate()" class="document-exchange-rate form-control text-right " placeholder="0,0000"
                   :readonly="readonlyProperties.exchangeRate"
                   :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                   v-model="exchangeRate"
                   @change="handleExchangeRateChange"
                   @keydown="preventNonNumbers($event)"
                   :disabled="disabled">
        </td>
        <td>
            <input type="text" v-if="showExchangedAmount()" class="document-exchanged-amount form-control text-right" placeholder="0,00"
                   :class="{'protect-unsaved-changes': method != null && method !== 'show'}"
                   :readonly="readonlyProperties.exchangedAmount"
                   v-model="exchangedAmount"
                   @change="handleExchangedAmountChange"
                   @keydown="preventNonNumbers($event)"
                   :disabled="disabled">
          <span class="help-block text-danger" v-if="hasError">{{ errorMessage[1] }}</span>
        </td>
        <td class="td-padding target_currency" colspan="4" v-if="showExchangedAmount()">
            {{isOperationAndDocumentCurrencyEqual() ? '' : document.currency}}
        </td>
    </tr>

</template>

<script>
import {Money} from '../../services/Money';
import filters from '../../services/Filters.js';
import mutations from '../../vuex/mutation_types.js'
import events from "../../services/Events";
import Allocation from "../../helpers/allocation";
import axios from "axios";

export default {
        name: "ModalDocumentLine",
        data: function() {
            return {
                submitted: false,
                modalData :null,
                money: new Money(),
                readonlyProperties: {
                    documentAmount: true,
                    exchangeRate: true,
                    exchangedAmount: true,
                },
                documentBalance: '0',
                documentBalanceAfterAllocation: '0',
                allocationAmount: '0',
                exchangeRate: this.isOperationNonDefaultCurrencyDocumentDefault() ? '0,0000' : '1,0000',
                exchangedAmount: '0',
                checkboxChecked: false,
                hasLoadedData: false,
                totalAllocated: '0',
                sum: 0,
            }
        },
        props: ['document', 'operation', 'index', 'method', 'disabled', 'documentType', 'modalType', 'colspan', 'context', 'hasError', 'errorMessage'],
        filters: filters,
        methods: {
            getOperationAllocatedDocuments: function () {
                if(this.modalContext !== undefined){

                    return this.modalContext.documentPayments.concat(this.modalContext.contractorTransfers).filter(flow_connection => {
                        return flow_connection.source_id == this.getOperationParentOrSelf(this.operation).id && flow_connection.target_id === this.document.document_id && flow_connection.target_type == 'App\\Document'
                    });
                }
                return {};

            },
            getOperationAllocationsForDocument: function () {
                return this.operation.allocations.filter(flow_connection => {
                    return flow_connection.target_id === this.document.document_id
                });
            },
            getFirstAllocationAmount: function () {
              return this.isDocumentAllocatedForOperation() ? this.getOperationAllocatedDocuments()[0].source_amount : 0;
            },
            getFirstAllocationExchangedAmount: function () {
                return this.isDocumentAllocatedForOperation() ? this.getOperationAllocatedDocuments()[0].target_amount : 0;
            },
            getFirstAllocationExchangeRate: function () {
                return this.isDocumentAllocatedForOperation() ? (this.getOperationAllocatedDocuments()[0].exchange_rate !== null ? this.getOperationAllocatedDocuments()[0].exchange_rate : 0) : this.document.exchange_rate;
            },
            getFirstOperationAllocationsForDocument: function () {
                return this.isDocumentAllocatedForOperation() ? this.getOperationAllocationsForDocument()[0].amount : 0;
            },
            isDocumentAllocatedForOperation: function () {
                return this.getOperationAllocatedDocuments().length > 0;
            },
            isOperationAllocationsForDocument: function () {
                return this.getOperationAllocationsForDocument().length > 0;
            },
            isOperationAndDocumentCurrencyEqual: function () {
                return this.operation.source_currency_id === this.document.currency_id;
            },
            getOperationParentOrSelf: function(operation) {
                return this.$store.getters.getOperationParentOrSelf(operation)
            },
            getOperationRootOrSelf: function(operation) {
              return this.$store.getters.getOperationRootOrSelf(operation)
            },
            getDocumentCheckboxState: function () {
                return this.$store.getters.getModalCheckboxes(this.operation.id).documents[this.index];
            },
            getUnallocatedPayments: function () {
                let context = this;
                return this.modalContext.unallocated_payments.filter(allocation => {
                    return allocation.operation_id === context.operation.id
                });
            },
            isUnallocatedPayment: function () {
                return this.getUnallocatedPayments().length > 0;
            },
            getFirstUnallocatedPaymentLocalBalance: function () {
                return this.isUnallocatedPayment() ? this.getUnallocatedPayments()[0].allocation.local_balance : 0;
            },
            handleReadonlyPropertiesChange: function () {
                if (this.documentType === 'contractorDocument') {
                    this.readonlyProperties.documentAmount = true;
                    this.readonlyProperties.exchangeRate = true;
                    this.readonlyProperties.exchangedAmount = true;
                } else if (this.document.currency_is_default && !this.source.currency_is_default) {
                    this.readonlyProperties.documentAmount = !this.checkboxChecked;
                    this.readonlyProperties.exchangeRate = !this.checkboxChecked;
                } else if (!this.document.currency_is_default && this.source.currency_is_default) {
                    this.readonlyProperties.documentAmount = !this.checkboxChecked;
                } else {
                    if (!this.showExchangedAmount()) {
                        this.readonlyProperties.documentAmount = !this.checkboxChecked;
                    } else {
                        if(this.showExchangeRate())
                        {
                            this.readonlyProperties.exchangeRate = !this.checkboxChecked;
                        } else {
                            this.readonlyProperties.documentAmount = !this.checkboxChecked;
                        }
                        this.readonlyProperties.exchangedAmount = !this.checkboxChecked;
                    }
                }

                if (!this.useExchangeRates && !this.isDocumentAndSourceSameCurrency()) {
                    this.readonlyProperties.exchangedAmount = !this.checkboxChecked;
                }
            },
            handleDocumentDelete: function (allocationAmount) {
                this.$emit('documentDeleted', allocationAmount)
            },
            handleCheckboxChange: function (event) {
                this.checkboxChecked = event.target.checked;
                this.handleReadonlyPropertiesChange();

                const max = this.document.currency_is_default || this.isDocumentAndOperationSameCurrencies()
                    ? this.money.toFloat(this.documentBalance)
                    : this.money.toFloat(this.documentBalance) * this.money.toFloat(this.exchangeRate);
                if(this.checkboxChecked) {
                    if(this.isDocumentAndOperationSameCurrencies() && this.isOperationAndDocumentAmountSameSign()){
                        this.allocationAmount = this.money.localize(max);
                    }
                    else if(this.source.currency_is_default && !this.document.currency_is_default && this.exchangeRate && this.isOperationAndDocumentAmountSameSign()){
                        this.allocationAmount = this.money.localize(max);
                    }
                    else{
                        this.allocationAmount = this.money.localize(0);
                    }
                    // else if(this.isDocumentAndOperationDifferentCurrency() && !this.useExchangeRates) {
                    //     this.allocationAmount = this.money.localize(0);
                    //     this.exchangedAmount = this.money.localize(0);
                    // } else if(this.isOperationNonDefaultCurrencyDocumentDefault() || this.isOperationNonDefaultCurrencyDocumentNonDefault()) {
                    //     this.allocationAmount = this.money.localize(0);
                    //     this.exchangeRate = this.money.localize(0, 4);
                    //     this.exchangedAmount = this.money.localize(0);
                    // } else if (((this.isDocumentAndOperationSameCurrencies() || this.useExchangeRates) || (this.source.currency_is_default && this.money.toFloat(this.operation.formatted_amount) < 0))
                    //     && this.isOperationAndDocumentAmountSameSign()) {
                    //     this.allocationAmount = this.money.localize(max);
                    // }
                } else {
                    this.documentBalanceAfterAllocation = this.money.localize(this.money.toFloat(this.allocationAmount) + this.money.toFloat(this.documentBalanceAfterAllocation));
                    this.allocationAmount = this.money.localize(0);
                    this.exchangedAmount = this.money.localize(0);
                }
                this.handleAmountChange();
                this.notifyAllocationChanged();
            },
            notifyAllocationChanged: function () {
                let data = {
                    allocation: Allocation.fromObject({
                        amount: this.allocationAmount,
                        operation_id: this.operation.id,
                        allocation_id: this.document.document_id,
                        currency: this.operation.currency,
                        exchange_rate: this.exchangeRate,
                        exchanged_amount: this.exchangedAmount,
                        exchange_target_currency: this.document.currency,
                        checked: this.checkboxChecked,
                    }),
                    index: this.index,
                    contractor_id: this.document.contractor_id
                }
                this.$emit('documentAllocationChanged', data)
            },
            requestNewForTotalAllocation: function (allocationAmount) {
                this.$emit('totalAllocatedChanged', {
                    amount: allocationAmount,
                    index: this.index,
                })
            },
            updateBalanceAfterAllocation: function (connected) {
                this.documentBalanceAfterAllocation = this.money.localize(this.money.toFloat(this.documentBalance) - connected);

                this.$emit('dynamicChangeDocumentBalance', {
                    'balanceAfterAllocation': this.documentBalanceAfterAllocation,
                    'documentId': this.document.document_id
                });
            },
            handleAmountChange: function() {
                this.allocationAmount = this.validateSign(this.allocationAmount);
                this.requestNewForTotalAllocation(this.allocationAmount);
                if(Math.abs(this.money.toFloat(this.totalAllocated)) >= Math.abs(this.money.toFloat(this.operationAmount))) {
                    this.allocationAmount = this.money.localize(this.money.toFloat(this.operationAmount) - (this.money.toFloat(this.totalAllocated) - this.money.toFloat(this.allocationAmount)))
                } else {
                    this.allocationAmount = this.money.localize(this.money.toFloat(this.$data.allocationAmount));
                }
                let connected = this.money.toFloat(this.allocationAmount);

                if(this.isDocumentNonDefaultCurrencySourceDefault() && this.showExchangeRate()){
                    connected /= this.money.toFloat(this.exchangeRate)
                    this.exchangedAmount = this.money.localize(connected);

                } else if(this.showExchangeRate()) {
                    connected *= this.money.toFloat(this.exchangeRate)
                    this.exchangedAmount = this.money.localize(connected);

                } else if(!(this.isOperationNonDefaultCurrencyDocumentNonDefault() && this.isDocumentAndOperationDifferentCurrency())){
                    this.exchangedAmount = this.money.localize(connected);
                }

                if((this.isDocumentAndSourceSameCurrency() || (this.isDocumentOrSourceDefaultCurrency() && this.useExchangeRates)) &&
                    !(this.isOperationNonDefaultCurrencyDocumentNonDefault() && this.isDocumentAndOperationDifferentCurrency())) {
                    this.updateBalanceAfterAllocation(connected)
                }
                this.notifyAllocationChanged();
            },
            handleExchangedAmountChange: function() {
                this.exchangedAmount = this.validateSign(this.exchangedAmount);
                if (this.isDocumentNonDefaultCurrencySourceDefault() && this.showExchangeRate()) {
                    this.allocationAmount = this.money.localize(this.money.toFloat(this.exchangedAmount) *  this.money.toFloat(this.exchangeRate));
                } else if(this.showExchangeRate()) {
                    this.allocationAmount = this.money.localize(this.money.toFloat(this.exchangedAmount) / this.money.toFloat(this.exchangeRate));
                }

                if(!this.useExchangeRates || this.isDocumentAndSourceSameCurrency() ||
                    (this.isOperationNonDefaultCurrencyDocumentNonDefault() && this.isDocumentAndOperationDifferentCurrency())) {
                    this.updateBalanceAfterAllocation(this.money.toFloat(this.exchangedAmount))
                }
                this.notifyAllocationChanged();
            },

            handleExchangeRateChange: function() {
                if(this.isOperationNonDefaultCurrencyDocumentDefault()) {
                    this.exchangeRate = this.money.localize(this.exchangeRate, 4, 16);
                }
                let connected = 0;
                if (this.isDocumentNonDefaultCurrencySourceDefault()) {
                    connected = this.money.toFloat(this.allocationAmount) / this.money.toFloat(this.exchangeRate)
                    this.exchangedAmount = this.money.localize(connected);

                } else if(this.showExchangeRate()) {
                    connected = this.money.toFloat(this.allocationAmount) * this.money.toFloat(this.exchangeRate)
                    this.exchangedAmount = this.money.localize(connected);
                }
                this.updateBalanceAfterAllocation(connected);
                this.notifyAllocationChanged();
            },
            isDifferentNonDefaultCurrencies: function() {
                return !this.operation.currency_is_default
                    && !this.document.currency_is_default
                    && (this.operation.currency !== this.document.currency);
            },
            isDocumentOrOperationCurrencyDefault: function () {
                return this.document.currency_is_default || this.operation.currency_is_default;
            },
            showExchangeRate: function() {
                let useExchangeRates = !this.isDocumentAndOperationSameCurrencies()
                    && this.isDocumentOrOperationCurrencyDefault()
                    && this.useExchangeRates;
                if(useExchangeRates || (!this.isDocumentAndOperationSameCurrencies() && this.isDocumentOrOperationCurrencyDefault()) ){
                    this.$emit('showAdditionalHeaders')
                }
                return useExchangeRates || (!this.isDocumentAndOperationSameCurrencies() && this.isDocumentOrOperationCurrencyDefault());
            },
            showExchangedAmount: function() {
                return this.isDifferentNonDefaultCurrencies()
                    || !this.isDocumentAndOperationSameCurrencies()
                    || (!this.useExchangeRates && !this.isDocumentAndOperationSameCurrencies());
            },
            isDocumentAndOperationSameCurrencies: function() {
                return this.operation.currency === this.document.currency
            },
            isWithoutExchangeRates: function() {
                if(!this.useExchangeRates) throw new Error('modal option: exchange rate allocation method is missing');
                return this.useExchangeRates
            },
            isOperationAndDocumentAmountSameSign() {
                return !this.isOppositeSign(this.money.toFloat(this.operation.formatted_amount), this.document.balance);
            },
            isOppositeSign: function(value1, value2)  {
                return (value1 * value2) < 0;
            },
            calculateExchangedAmountFromAmount: function(amount) {
                let exchanged_amount = Math.abs(this.isOperationDefaultCurrencyDocumentNonDefault()
                    ? amount / this.exchangeRate
                    : amount * this.exchangeRate
                );
                return isFinite(exchanged_amount) ? Math.abs(exchanged_amount) : 0;
            },
            calculateAmountFromExchangedAmount: function(exchanged_amount) {
                let amount = (this.isOperationNonDefaultCurrencyDocumentDefault()
                        ? exchanged_amount * this.exchangeRate
                        : exchanged_amount / this.exchangeRate
                );
                return isFinite(amount) ? Math.abs(amount) : 0;
            },
            isOperationDefaultCurrencyDocumentNonDefault: function () {
                return this.operation.currency_is_default && !this.document.currency_is_default;
            },
            isOperationNonDefaultCurrencyDocumentDefault: function () {
                return !this.operation.currency_is_default && this.document.currency_is_default;
            },
            isOperationNonDefaultCurrencyDocumentNonDefault: function () {
              return !this.document.currency_is_default && !this.operation.currency_is_default;
            },
            isDocumentNonDefaultCurrencySourceDefault: function () {
                return !this.document.currency_is_default && this.source.currency_is_default;
            },
            isDocumentOrSourceDefaultCurrency: function (){
                return this.isDocumentDefaultCurrencySourceNonDefault || this.isDocumentNonDefaultCurrencySourceDefault()
            },
            isDocumentDefaultCurrencySourceNonDefault: function () {
                return this.document.currency_is_default && !this.source.currency_is_default;
            },
            isDocumentAndSourceSameCurrency: function () {
                return this.document.currency === this.source.currency;
            },
            isDocumentAndOperationDifferentCurrency: function () {
                return this.document.currency !== this.operation.currency;
            },
            validateSign: function (value) {
                const operationAmountFloat = this.money.toFloat(this.operation.formatted_amount);
                const valueFloat = this.money.toFloat(value);
                const mod = (valueFloat > 0 && operationAmountFloat < 0) || (valueFloat < 0 && operationAmountFloat > 0) ? -1 : 1;
                return this.money.localize(valueFloat * mod);
            },
            preventNonNumbers: function($event) {
                let allowed = [
                    'Digit1','Digit2','Digit3','Digit4','Digit5','Digit6','Digit7','Digit8','Digit9','Digit0',
                    'Comma', 'Minus',
                    'Tab', 'Delete', 'Insert', 'ArrowLeft', 'ArrowRight', 'Escape', 'Backspace', 'F5', 'Enter',
                    'Numpad0', 'Numpad1', 'Numpad2', 'Numpad3', 'Numpad4', 'Numpad5', 'Numpad6', 'Numpad7', 'Numpad8', 'Numpad9',
                    'NumpadComma', 'NumpadDecimal', 'NumpadSubtract', 'NumpadEnter'

                ];
                if(!allowed.includes($event.code)) {
                    console.log($event.code);
                    $event.preventDefault();
                }
            },
            loadValues: function() {
                this.documentBalance = this.money.localize(this.money.toFloat(this.document.balance_before_connection) + this.money.toFloat(this.getFirstAllocationExchangedAmount()))
                this.documentBalanceAfterAllocation = this.money.localize(this.money.toFloat(this.document.balance_before_connection));
                this.allocationAmount = this.money.localize(this.money.toFloat(this.getFirstAllocationAmount()));

                if(!this.isOperationNonDefaultCurrencyDocumentDefault() || this.isDocumentAllocatedForOperation()) {
                    this.exchangeRate  = this.money.localize(this.money.toFloat(this.getFirstAllocationExchangeRate()), 4, 16);
                }
                this.exchangedAmount = this.money.localize(this.money.toFloat(this.getFirstAllocationExchangedAmount()));
                this.checkboxChecked = this.getDocumentCheckboxState();
                if(this.documentType === "contractorDocument") {
                    this.notifyAllocationChanged();
                }
            },
        },
        computed: {
             operationAmount: function() {
                return this.operation.formatted_amount;
            },
            modalContext: function () {
              return this.context
            },
            useExchangeRates: function () {
                return this.$store.getters.getUseExchangeRates;
            },
            checkboxName: function () {
                return '[document_split][document_' + this.index + '][checkbox]';
            },
            documentConnectedAmountName: function () {
                return '[document_split][document_' + this.index +'][amount]'
            },
            documentBalanceAfterAllocationName: function () {
                return '[document_split][document_' + this.index + '][balance_after_allocation]';
            },
            source: function () {
              return this.operation.payment_source ?? this.$store.getters.getSource;
            },
            stateToCommit: function () {
                return this.$store.getters.getStateToCommit;
            },
        },
    mounted() {
            const self = this;
            this.$store.commit(mutations.SET_MODAL_DOCUMENT_CHECKBOX, {
                'operationId': this.operation.id,
                'index': this.index,
                'checked': this.isDocumentAllocatedForOperation()
            });

            this.loadValues();
            if(this.documentType === 'operationDocument') {
                this.notifyAllocationChanged();
            }

            this.handleReadonlyPropertiesChange();
            events.$on('totalAllocatedChanged', (data) => {
                this.totalAllocated = data.totalAllocated
            });
            events.$on('storeCheckboxState', function (data) {
                if(data.operationId === self.operation.id){
                    self.$store.commit(mutations.SET_MODAL_DOCUMENT_CHECKBOX, {
                        operationId: self.operation.id,
                        index: self.index,
                        checked: self.checkboxChecked
                    });
                }
            });
        },
    }
</script>

<style scoped>
.tr-errors > td {
  border: 0 !important;

}
.document-exchange-rate{
    width: 140px !important;
}
.disabledIcon {
    pointer-events: none;
}

.disabledIcon > i {
    color: #E9ECEF;
}
</style>
